import { gql } from '@apollo/client';

export const SUYP_GET_COMPLETED_TASK_EVENTS = gql`
  query SUYPGetCompletedTaskEvents($completedTaskId: String!) {
    vm {
      completedTask(completedTaskId: $completedTaskId) {
        completedTaskId
        events {
          completedTaskEventId
          message
          status
          startDateTime
          endDateTime
          placesAddress {
            description
            formatted
            placesId
            latLong {
              lat
              long
            }
          }
          remoteLocation
          managers {
            managerId
            profile {
              firstName
              lastName
            }
          }
          participantFeedback
          rescheduleCount
          originalScheduledDate
          dateCreated
        }
      }
    }
  }
`;

export const SUYP_GET_EVENT_TASK = gql`
  query SUYPGetEventTask($taskId: String!, $userId: String!) {
    vm {
      task(taskId: $taskId) {
        taskId
        title
        description
        isEventTask
      }
      # Get completed tasks through profile to avoid the application filter
      profile(userId: $userId) {
        profileId
        completedTasks {
          completedTaskId
          status
          task {
            taskId
            isEventTask
          }
        }
      }
    }
  }
`;